// Converts a color object {r, g, b, a} (from RgbaColorPicker) to "#RRGGBBAA" hex string
export const rgbaObjToHex = ({ r, g, b, a }) => {
    const toHex = (n) => Math.round(n).toString(16).padStart(2, '0').toUpperCase();
    return `#${toHex(r)}${toHex(g)}${toHex(b)}${toHex(Math.round(a * 255))}`;
};

// Converts a "#RRGGBBAA" hex string back to a color object {r, g, b, a}
export const hexToRgbaObj = (str) => {
    const match = str && str.match(/^#([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
    if (!match) return { r: 255, g: 255, b: 255, a: 1 };
    return {
        r: parseInt(match[1], 16),
        g: parseInt(match[2], 16),
        b: parseInt(match[3], 16),
        a: parseInt(match[4], 16) / 255,
    };
};
